const LOGO = `
   <svg class="brand-logo sm" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
   <rect x="2" y="2" width="44" height="44" rx="10" fill="#1f7a4d"/>
   <rect x="9" y="9" width="12" height="12" rx="2.5" fill="#fff" opacity=".92"/>
   <rect x="9" y="27" width="12" height="12" rx="2.5" fill="#fff" opacity=".55"/>
   <rect x="27" y="9" width="12" height="12" rx="2.5" fill="#fff" opacity=".55"/>
   <rect x="27" y="27" width="12" height="12" rx="2.5" fill="#fff" opacity=".92"/>
</svg>`;

class AppHeader extends HTMLElement {
   connectedCallback() {
      this.innerHTML = `
         <header class="app-head">
            <div class="app-brand">${LOGO}
               <div>
                  <div class="app-name">Grid<span>Professor</span></div>
                  <p class="sub" id="subtitle">Loading…</p>
               </div>
            </div>
         </header>`;
   }
}
customElements.define("app-header", AppHeader);
